import React from 'react';

export const GeometricStacks = ({ ...rest }) => {
  return (
    <svg
      width="340"
      height="397"
      viewBox="0 0 340 397"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g filter="url(#filter0_d_502_1135)">
        <path
          d="M141.539 249.741H1.55428L1.55428 76.6609C7.44217 76.6609 12.8683 73.4723 15.7335 68.3285L24.8644 51.9363C39.7654 25.1854 75.5199 18.9502 98.596 39.0784L149.623 83.587C192.376 120.878 196.931 185.717 159.812 228.62L141.539 249.741Z"
          fill="#DEEBFE"
        />
      </g>
      <g filter="url(#filter1_d_502_1135)">
        <path
          d="M319.171 400L71.5026 400L1.81345 290.155L183.663 165.621C203.807 151.826 231.526 162.473 237.255 186.206L258.86 275.714C259.504 278.383 260.86 280.828 262.783 282.789L308.21 329.107C326.685 347.944 331.094 376.463 319.171 400Z"
          fill="#225E9C"
        />
      </g>
      <g filter="url(#filter2_d_502_1135)">
        <path
          d="M235.233 400L0 400L0 220.186L8.06958 215.368C78.9382 173.062 169.805 218.34 178.706 300.395C180.998 321.53 189.194 341.593 202.354 358.289L235.233 400Z"
          fill="#2178F6"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_502_1135"
          x="-28.4458"
          y="17.2047"
          width="213.37"
          height="252.536"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-15" dy="5" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_502_1135" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_502_1135"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_502_1135"
          x="-28.1865"
          y="149.497"
          width="354"
          height="270.503"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-15" dy="5" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_502_1135" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_502_1135"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_502_1135"
          x="-30"
          y="189.238"
          width="265.233"
          height="230.762"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-15" dy="5" />
          <feGaussianBlur stdDeviation="7.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_502_1135" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_502_1135"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default GeometricStacks;



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/GeometricStacks.jsx